import {
  Icon,
  Panel,
  SageClassnames,
  SageTokens,
  Tooltip,
  Frame,
} from '@kajabi/sage-react';
import {
  AUTOMATION_TOOLTIP_COPY,
  FORM_TOOLTIP_COPY,
} from '../../../utils/constants';

const BusinessPreviewSubPanelRow = () => {
  return (
    <div className={SageClassnames.SPACERS.LG_LEFT}>
      <Panel.Row gridTemplate="et" className={SageClassnames.SPACERS.SM_BOTTOM}>
        <Icon
          icon="form-field"
          size="md"
          className="sage-icon-background sage-title-icon"
          style={{
            background: '#000000',
            color: '#ffffff',
            width: 36,
            height: 36,
          }}
        />
        <Frame gap={Frame.GAPS.XS} direction={Frame.DIRECTIONS.HORIZONTAL}>
          Form
          <Tooltip
            content={
              <p className={SageClassnames.TYPE.BODY_SMALL}>
                {FORM_TOOLTIP_COPY}
              </p>
            }
            position={Tooltip.POSITIONS.RIGHT}
          >
            <Icon icon={SageTokens.ICONS.INFO_CIRCLE} />
          </Tooltip>
        </Frame>
      </Panel.Row>
      <Panel.Row gridTemplate="et">
        <Icon
          icon={Icon.ICONS.FLASH}
          size="md"
          className="sage-icon-background sage-title-icon"
          style={{
            background: '#000000',
            color: '#ffffff',
            width: 36,
            height: 36,
          }}
        />
        <Frame gap={Frame.GAPS.XS} direction={Frame.DIRECTIONS.HORIZONTAL}>
          Automation
          <Tooltip
            content={
              <p className={SageClassnames.TYPE.BODY_SMALL}>
                {AUTOMATION_TOOLTIP_COPY}
              </p>
            }
            position={Tooltip.POSITIONS.RIGHT}
          >
            <Icon icon={SageTokens.ICONS.INFO_CIRCLE} />
          </Tooltip>
        </Frame>
      </Panel.Row>
    </div>
  );
};

export default BusinessPreviewSubPanelRow;
